import { replacePlaceholders } from './seo-content';

const formatPageTitle = (...titles: string[]) => {
  const companyName = 'Checkatrade';
  const separator = ' | ';

  if (titles.length === 1) {
    const title = titles[0];

    if (!title?.trim().length) {
      return companyName;
    }

    if (title.endsWith(`${separator}${companyName}`)) {
      return title;
    }
  }

  return [...titles, companyName].join(separator);
};

type Options = {
  metaTitle?: string;
  location?: string;
  categoryLabel?: string;
  totalResults?: number;
};

export const getMetaTitle = ({
  metaTitle,
  location,
  totalResults,
  categoryLabel,
}: Options = {}) => {
  if (metaTitle && location && totalResults !== undefined) {
    return replacePlaceholders({
      tokenisedString: metaTitle,
      categoryLabel,
      location,
      totalResults,
    });
  }

  if (categoryLabel && location) {
    return `${categoryLabel} in ${location} | Find Trusted Experts | Checkatrade`;
  }

  return 'Search by category | Find Trusted Experts | Checkatrade';
};

export default formatPageTitle;
